import{makeAccessor}from"../../core/index.js";export const breakpoint=makeAccessor({xxl:1920,xl:1440,lg:1024,md:768,sm:480});
//# sourceMappingURL=breakpoint.js.map